export const createGameSettingsSlice = ({ initialGameSettings, gameInfo })=>(set, get)=>({
            gameSettings: {
                roomId: initialGameSettings.id,
                gameType: initialGameSettings.gameType,
                isPrivateGame: initialGameSettings.privateGame,
                isPlayOrderSelectionActive: initialGameSettings.playOrderSelectionActive,
                minimumKarma: initialGameSettings.minimumKarma,
                eloType: initialGameSettings.eloType,
                modeSetting: initialGameSettings.modeSetting,
                extensionSetting: initialGameSettings.extensionSetting,
                scenarioSetting: initialGameSettings.scenarioSetting,
                mapSetting: initialGameSettings.mapSetting,
                diceSetting: initialGameSettings.diceSetting,
                victoryPointsToWin: initialGameSettings.victoryPointsToWin,
                isKarmaActive: initialGameSettings.karmaActive,
                setIsKarmaActive: (isKarmaActive)=>{
                    set({
                        gameSettings: {
                            ...get().gameSettings,
                            isKarmaActive: isKarmaActive
                        }
                    });
                },
                cardDiscardLimit: initialGameSettings.cardDiscardLimit,
                maxPlayers: initialGameSettings.maxPlayers,
                gameSpeed: initialGameSettings.gameSpeed,
                botSpeed: initialGameSettings.botSpeed,
                hideBankCards: initialGameSettings.hideBankCards,
                friendlyRobber: initialGameSettings.friendlyRobber,
                gameInfo: gameInfo
            }
        });
